export const portfolioKpis: Array<{
  label: string;
  value: string;
  note: string;
  tone?: "warning";
}> = [
  { label: "Residents engaged", value: "18,420", note: "+9% versus last year" },
  { label: "Return rate", value: "54%", note: "After a first attendance" },
  { label: "In 2+ programs", value: "23%", note: "+2 points this year" },
  { label: "Attendance rate", value: "71%", note: "Of registered sessions" },
  { label: "No-show rate", value: "19%", note: "3 points lower versus last year", tone: "warning" },
  { label: "Satisfaction", value: "4.2 / 5", note: "From post-program feedback" },
] as const;

export const engagementLadder = [
  { label: "Registered", value: "24,870", rate: 100 },
  { label: "Attended", value: "18,420", rate: 74 },
  { label: "Returned", value: "13,310", rate: 54 },
  { label: "Joined 2+ programs", value: "5,737", rate: 23 },
  { label: "Referred a neighbor", value: "3,481", rate: 14 },
] as const;

export const districtReach = [
  { district: "District 3", rate: 32, residents: "2,890" },
  { district: "District 4", rate: 28, residents: "2,462" },
  { district: "District 5", rate: 25, residents: "2,116" },
  { district: "District 12", rate: 22, residents: "1,934" },
  { district: "District 9", rate: 18, residents: "1,478" },
] as const;

export const programComparison = [
  {
    program: "Community Garden Program",
    department: "Parks & Recreation",
    residents: "4,280",
    attendance: "83%",
    returnRate: "68%",
    secondProgram: "31%",
    satisfaction: "4.6",
    action: "Scale referral practice",
  },
  {
    program: "Digital Skills Workshops",
    department: "Atlanta Information Management",
    residents: "3,960",
    attendance: "76%",
    returnRate: "58%",
    secondProgram: "26%",
    satisfaction: "4.3",
    action: "Invite to workforce pathway",
  },
  {
    program: "Youth Sports & Fitness",
    department: "Parks & Recreation",
    residents: "3,410",
    attendance: "74%",
    returnRate: "61%",
    secondProgram: "24%",
    satisfaction: "4.5",
    action: "Maintain family outreach",
  },
  {
    program: "Financial Literacy Series",
    department: "Mayor's Office",
    residents: "2,170",
    attendance: "59%",
    returnRate: "28%",
    secondProgram: "11%",
    satisfaction: "3.8",
    action: "Test reminder sequence",
  },
  {
    program: "Neighborhood Planning Labs",
    department: "City Planning",
    residents: "1,820",
    attendance: "66%",
    returnRate: "43%",
    secondProgram: "17%",
    satisfaction: "4.0",
    action: "Add childcare support",
  },
] as const;

export const residentsAtRisk = [
  {
    group: "Registered but did not attend",
    residents: "4,730",
    signal: "High no-show concentration in Financial Literacy and Planning Labs",
    action: "Send reminders 48 hours and 3 hours before each session.",
  },
  {
    group: "Attended once but did not return",
    residents: "5,110",
    signal: "Drop-off after a first program visit",
    action: "Offer a tailored second-program invitation within seven days.",
  },
  {
    group: "Low-reach council districts",
    residents: "3 districts",
    signal: "Participation under 22% in Districts 9, 12, and 5",
    action: "Move pop-ups to trusted neighborhood venues.",
  },
] as const;

export const portfolioRecommendations = [
  "Build one standard second-program referral into every completed event.",
  "Reuse Community Garden follow-up language in lower-return programs.",
  "Prioritize reminder and access tests before increasing program volume.",
] as const;
